class ConnectionList{
    constructor(container){
        this._container = ge(container);
        this._connections = [];
		this._currentConnection = null;

		this.orderBy = ge('order-by');
		this.filters = new FilterList();

		this.filters.addGroup('Teams', 'team', teams);

		onEv(this.orderBy, 'change', this.fetch.bind(this));

		this._moreMenu = Dialog.Popup('connection-context', [
			this._removeConnectionBtn = btn('popup-list-btn', _("Remove")),
			this._permissionsBtn = btn('popup-list-btn', _("Permissions")),
			this._stopSuperBtn = btn('popup-list-btn', _("Stop supervising")),
			this._startSuperBtn = btn('popup-list-btn', [icon('add-super'), _('Request supervision')])
		], 'left-end');

        onEv(document, 'primaryDataInvalid filterSelected', this.fetch.bind(this));
		onEv(this._removeConnectionBtn, 'click', this.remove.bind(this));
		onEv(this._permissionsBtn, 'click', this.showPermissions.bind(this));
		onEv(this._stopSuperBtn, 'click', this.stopSupervising.bind(this));
		onEv(this._startSuperBtn, 'click', this.reqSupervising.bind(this));

		this.fetch();
    }

	get current() {return this._currentConnection;}

    fetch() {
		API.get(
			`connections/list?order=${this.orderBy.value}` +
			this.filters.toString
		)
		.then (json => {
			this._connections = [];
			this._container.innerHTML = '';
            if (json.connections) {
				if (json.connections.length == 0) {
					this._container.appendChild(this.emptyState = div('no-content', [
					htm('h2', null, _("Let's fill this empty space!")),
						img(null, '/images/space/space-man.png'),
						p(null, [
							// btn('btn ', img(null, '/images/space/video-btn.png'), {
							// 	'click': () => pageFlow.fromStart(2)
							// }),
							btn('btn ', img(null, '/images/space/guide-btn.png'), {
								'click': () => pageFlow.fromStart(11)
							})
						])
					]));
				}
                json.connections.forEach(function(data){
                    let connection = Connection.fromArray(data, this);
                    this._connections.push(connection);
                    this._container.appendChild(connection.getElem(json.subscription));
                }, this);
				document.dispatchEvent(new Event('primaryDataLoaded'));
            }
		});
    }

	showMoreMenu(connection) {
		this._currentConnection = connection;
		this._removeConnectionBtn.style.display = (connection.isSupervised || connection.isSupervisor) ? 'none' : 'block';
		this._permissionsBtn.style.display = connection.isSupervised ? 'block' : 'none';
		this._stopSuperBtn.style.display = connection.isSupervised ? 'block' : 'none';
		this._startSuperBtn.style.display = (hasSubscription && !isSupervisor && !connection.isSupervisor) ? 'block' : 'none';
		this._moreMenu.handle(connection.moreButton);
	}

	showTeamsList() {
		if (!connectionGroups instanceof ConnectionGroupList) return;
		if (this._currentConnection)
			connectionGroups.openDialog(this._currentConnection);
	}

	remove(connection) {
		if (this._currentConnection != null) {
			this._currentConnection.remove();
			this._currentConnection = null;
		}
		if (connection instanceof Connection) {
			let i = this._connections.indexOf(connection);
			this._connections.splice(i, 1);
		} 
	}

	showPermissions() {
		if (permissions instanceof Permissions && this._currentConnection) {
			permissions.open(this._currentConnection);
		}
	}

	reqSupervising() {
		if (supervision instanceof Supervision && this._currentConnection) {
			supervision.requestSupervision(this._currentConnection.id);
		}
	}

	stopSupervising() {
		if (supervision instanceof Supervision && this._currentConnection) {
			supervision.stopSupervising(this._currentConnection.id);
		}
	}
}